module.exports = __webpack_public_path__ + "img/9788983782748.2493ff5b.jpg";